import { Tab, TabList, Tabs } from "@carbon/react";


export const View = ({
  // className,
  defaultSelectedIndex,
  selectedIndex,
  onChange,
  queryStringTabNavLinks,
  setQueryStringFilter,
  tabListType,
}) => {
  return (
    <Tabs
      defaultSelectedIndex={defaultSelectedIndex}
      selectedIndex={selectedIndex}
      onChange={onChange}
     
    >
      <TabList
        activation="manual"
        tabListType={tabListType}
        aria-label="List of tabs"
      >
        {queryStringTabNavLinks.options.map((qst) => (
          <Tab
            key={qst.value}
            onClick={() =>
              setQueryStringFilter(queryStringTabNavLinks.query, qst.value)
            }
          >
            {qst.key}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};
